import dayjs = require("dayjs");

function displayAlertMessage(message: string) {
    return `
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
            ${message} 
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
    `
}

export default function handleMakeOfferForm() {
    const startDate = document.querySelector('#make_offer_p1 input[name="offerStartDate"]') as HTMLInputElement;
    //let startDateJ = jQuery(startDate).datepicker() as any;
    const endDate = document.querySelector('#make_offer_p1 input[name="offerEndDate"]') as HTMLInputElement;

    const makeOfferForm = document.querySelector('#make_offer_form') as HTMLElement;
    var converter = require("number-to-chinese-words");
    converter.default.labels = Object.assign({},converter.default.labels, {
        digits : ['零','壹', '貳', '參', '肆', '伍', '陸', '柒', '捌', '玖'],
        units: ['','拾', '佰', '仟', '萬', '拾', '佰', '仟', '億', '拾', '佰', '仟', '兆', '拾', '佰', '仟', '京', '拾', '佰', '仟', '垓']
    })

    let handle = (e : Event) => {
        // console.log(startDate.value);
        // console.log(dayjs(startDate.value));
        // console.log(dayjs(startDate.value).add(2, 'year').subtract(1, 'day'));
        // endDate.value = dayjs(startDate.value).add(729, 'day').format('YYYY-MM-DD');
        endDate.value = dayjs(startDate.value).add(2, 'year').subtract(1, 'day').format('YYYY-MM-DD');
        jQuery(endDate).datepicker('setStartDate', endDate.value);
    }
    // Default set two year later after choosing the start date
    if (startDate) {
        startDate.addEventListener('change', handle);
        startDate.addEventListener('input', handle);
        jQuery(startDate).datepicker().on('changeDate', handle);
        
        // Set the start date not before today or not before the rent start date
        const rentStartDateElement = document.querySelector('#rentStartDate') as HTMLElement;
        const rentStartDate = rentStartDateElement.innerText;
        let rentStartDay, rentStartMonth, rentStartYear;
        [rentStartDay, rentStartMonth, rentStartYear] = rentStartDate.split('/');
        const formattedRentStartDate = `${rentStartYear}-${rentStartMonth}-${rentStartDay}`;

        if (rentStartDate) {
            if (new Date(formattedRentStartDate) <= new Date(dayjs().format('YYYY-MM-DD'))) {
                jQuery(startDate).datepicker('setStartDate', dayjs().format('YYYY-MM-DD'));
                jQuery(endDate).datepicker('setStartDate', dayjs().format('YYYY-MM-DD'));
            } else {
                jQuery(startDate).datepicker('setStartDate', formattedRentStartDate);
                jQuery(endDate).datepicker('setStartDate', formattedRentStartDate);
            }
        } else {
            jQuery(startDate).datepicker('setStartDate', dayjs().format('YYYY-MM-DD'));
            jQuery(endDate).datepicker('setStartDate', dayjs().format('YYYY-MM-DD'));
            // jQuery(endDate).css( 'pointer-events', 'none' );
        }
    }  

    if (makeOfferForm) {
        const tenantOfferChineseInput = makeOfferForm.querySelector('input[name="tenant_offer_price_chinese"]') as HTMLInputElement;
        const tenantDepositChineseInput = makeOfferForm.querySelector('input[name="tenant_offer_deposit_chinese"]') as HTMLInputElement;
        const tenantOfferInput = makeOfferForm.querySelector('input[name="tenantOffer"]') as HTMLInputElement;
        tenantOfferInput.addEventListener('keyup', e => {
            e.preventDefault();
            // console.log('chinese');
            let amount = tenantOfferInput.value;
            let deposit = Number(amount) * 2;
            tenantOfferChineseInput.value = converter.toWords(amount);
            tenantDepositChineseInput.value = converter.toWords(Number(deposit));
        })
    }
}

/*--------------------------------------------------------------------------
*  Make Offer - Ajax request when user make an offer
* -------------------------------------------------------------------------*/
export function handleMakeOfferSubmit() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';    
    jQuery( '.make_offer_form').on('click', function(e) {
            e.preventDefault();
    
            var $this = jQuery(this);
            var $form = $this.parents( 'form' );
            var $result = $form.find('.form_messages');
    
            jQuery.ajax({
                url: ajaxurl,
                data: $form.serialize(),
                method: $form.attr('method'),
                dataType: "JSON",
    
                beforeSend: function( ) {
                    $this.find('.houzez-loader-js').addClass('loader-show');
                },
                success: function(response) {
                    if( response.success ) {
                        $form.find('input[name="offerTenantName"], input[name="offerTenantIdCard"], input[name="offerTenantRegistrationNumber"], input[name="tenantOffer"], input[name="offerStartDate"], input[name="offerEndDate"]').val('');
                        $result.empty().append('<div class="alert alert-success alert-dismissible fade show" role="alert">'+response.msg+'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                    } else {
                        $result.empty().append('<div class="alert alert-danger alert-dismissible fade show" role="alert">'+response.msg+'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                    }
                },
                error: function(xhr, status, error) {
                    var err = eval("(" + xhr.responseText + ")");
                    console.log(err.Message);
                },
                complete: function(){
                    $this.find('.houzez-loader-js').removeClass('loader-show');
                }
            });
    
        });
}

/*--------------------------------------------------------------------------
*  Schedule Tour - Ajax request when landlord accept an offer
* -------------------------------------------------------------------------*/
export function handleOfferAccept() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    jQuery('.offer-accept-btn').on('click', function (e) {
        e.preventDefault();
        // console.log("accept!");

        const $this = jQuery(this);
        const $form = $this.parents('form');
        const $message = $this.parent().parent();
    
        jQuery.ajax({
            url: ajaxurl,
            data: $form.serialize(),
            method: $form.attr('method'),
            dataType: "JSON",
    
            beforeSend: function () {
                $this.find('.houzez-loader-js').addClass('loader-show');
            },
            success: function (response) {
                if (response.success) {
                    // $message.text(response.msg);
                    $message.html(response.msg);
                    $message.css({'display': 'block'});
                } else {
                    // $result.empty().append('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                }
            },
            error: function (xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                // console.log(err.Message);
            },
            complete: function () {
                $this.find('.houzez-loader-js').removeClass('loader-show');
            }
        });
    });
}

/*--------------------------------------------------------------------------
*  Schedule Tour - Ajax request when landlord deny an offer
* -------------------------------------------------------------------------*/
export function handleOfferDeny() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    jQuery('.offer-deny-btn').on('click', function (e) {
        e.preventDefault();
        // console.log("deny!");

        const $this = jQuery(this);
        const $form = $this.parents('form');
        const $message = $this.parent().parent();
    
        jQuery.ajax({
            url: ajaxurl,
            data: $form.serialize(),
            method: $form.attr('method'),
            dataType: "JSON",
    
            beforeSend: function () {
                $this.find('.houzez-loader-js').addClass('loader-show');
            },
            success: function (response) {
                if (response.success) {
                    $message.text(response.msg);
                } else {
                    // $result.empty().append('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                }
            },
            error: function (xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                // console.log(err.Message);
            },
            complete: function () {
                $this.find('.houzez-loader-js').removeClass('loader-show');
            }
        });
    });
}

/*--------------------------------------------------------------------------
*  Ajax for handling offer detail submit - for landlord and tenant sign
* -------------------------------------------------------------------------*/
export function handleOfferDetailSubmit() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    jQuery( '.offer-detail-submit').on('click', function(e) {
        e.preventDefault();
    
        var $this = jQuery(this);
        var $form = $this.parents( 'form' );
        var $result = $form.find('.form_messages');
    
        jQuery.ajax({
            url: ajaxurl,
            data: $form.serialize(),
            method: $form.attr('method'),
            dataType: "JSON",
    
            beforeSend: function( ) {
                $this.find('.houzez-loader-js').addClass('loader-show');
            },
            success: function(response) {
                if( response.success ) {
                    // $form.find('input[name="name"], input[name="phone"], input[name="email"]').val('');
                    // $form.find('textarea').val('');
                    if (response.offerUrl) {
                        $result.empty().append('<div class="alert alert-success alert-dismissible fade show" role="alert">'+response.msg+' <a href="'+response.offerUrl+'">按此</a> 返回交易頁面'+'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                    } else {
                        $result.empty().append('<div class="alert alert-success alert-dismissible fade show" role="alert">'+response.msg+'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                    }
                } else {
                    if (response.offerUrl) {
                        $result.empty().append('<div class="alert alert-danger alert-dismissible fade show" role="alert">'+response.msg+' <a href="'+response.offerUrl+'">按此</a> 返回交易頁面'+'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                    } else {
                        $result.empty().append('<div class="alert alert-danger alert-dismissible fade show" role="alert">'+response.msg+'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                    }
                }
            },
            error: function(xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
                console.log(err.Message);
            },
            complete: function(){
                $this.find('.houzez-loader-js').removeClass('loader-show');
            }
        });
    
    });
}

/*--------------------------------------------------------------------------
*  Dashboard records - Action taken when admin remark an offer
* -------------------------------------------------------------------------*/
export function handleOfferRemark() {
    var ajaxurl = (window as any).houzez_vars.admin_url+ 'admin-ajax.php';
    jQuery('.offer-remark-btn').on('click', function (e) {
        e.preventDefault();
        const $this = jQuery(this);
        const $form = $this.parents('form');
        const $remarkMsg = $form.parent().prev();
        const $remarkReviseBtn = $form.next();
        const $remarkAddBtn = $form.parent().parent().parent().prev();
    
        jQuery.ajax({
            url: ajaxurl,
            data: $form.serialize(),
            method: $form.attr('method'),
            dataType: "JSON",
    
            beforeSend: function () {

            },
            success: function (response) {
                if (response.success) {
                    console.log(response.msg);
                    $remarkMsg.text(response.msg);
                    $form.addClass('hide');
                    $remarkReviseBtn.removeClass('hide');
                    if(response.msg !== '') {
                        $remarkAddBtn.text('查看');
                    } else {
                        $remarkMsg.text('請在下方添加備註');
                        $remarkAddBtn.text('添加');
                    }
                }
            },
            error: function (xhr, status, error) {
                var err = eval("(" + xhr.responseText + ")");
            },
            complete: function () {

            }
        });
    });
    jQuery('.records-offer-remark-section-revise-btn').on('click', function(e) {
        e.preventDefault();
        const $this = jQuery(this);
        const $form = $this.prev();
        $form.removeClass('hide');
        $this.addClass('hide');
    })
}